import React from 'react';
import { Icon } from '@vectord/components';
import cogoToast from 'cogo-toast';

import FileSelect from 'components/FileSelect';
import Input from 'components/Input';

import styles from './ASLVideoExtraction.module.scss';

export default function ASLVideoExtraction({
  resetZipFile,
  zipFile,
  setZipFile,
}) {
  /**
   * Handles a file upload event. Checks if the file is a ZIP file and that it
   * is not larger than 500MB. If the file is valid, it sets the zipFile state
   * to the uploaded file.
   *
   * @param {FileList} files The list of files that were uploaded
   */
  const handleFileUpload = (files) => {
    if (files && files.length > 0) {
      const file = files[0];

      if (!file.name.toLowerCase().endsWith('.zip')) {
        cogoToast.error('Please upload a ZIP file.');
        return;
      }

      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        cogoToast.error('File is too large. Maximum file size is 500MB.');
        return;
      }

      setZipFile(file);
    }
  };

  if (zipFile) {
    return (
      <div className={styles.selectedFileNameContainer}>
        <Input
          value={zipFile.name}
          className={styles.selectedFileName}
          readOnly
        />
        <Icon
          name="clear"
          className={styles.closeIcon}
          onClick={resetZipFile}
        />
      </div>
    );
  } else {
    return (
      <div className={styles.fileDropContainer}>
        <FileSelect
          accept=".zip"
          onChange={handleFileUpload}
        >
          Click here to Upload ZIP file
        </FileSelect>
      </div>
    );
  }
}
